
import TicketExpired from "../../../assets/filled/TicketExpired.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TicketExpiredIcon({ className, dataTestid = "TicketExpiredIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TicketExpired data-testid={dataTestid} className={classes} {...rest} />
  );
}
